import { URL_NAVS } from '@/constants';
import { ICON_COLOR, ICON_SIZE_PX } from '@/controls/menu-constants';
import { useOptionalPropertyDeckardId } from '@/utils/hooks/usePropertyDeckardId';
import { useRootTab } from '@/utils/hooks/useRootTab';
import { StyledIconButton } from '@/widgets/components/styled-icon-button';
import FileDownloadIcon from '@rsuite/icons/FileDownload';
import { IconButton } from 'rsuite';
import styled from 'styled-components';
import { AcceptCheckModalButton } from '../accept-check-modal';
import { AdminApplyFlowButton } from '../admin-apply-flow-button';
import { StyledBalloon } from './dash-content-action-menu-styles';
import { SharePopover } from './share-popover';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 24px;
  min-width: 120px;

  > * {
    margin-left: 45px;
  }
`;

const IconTooltip = (props) => (
  <StyledBalloon
    aria-label={props.tooltip}
    data-balloon-pos="down"
    data-balloon-blunt
    className="action-menu-balloon-tooltip"
  >
    {props.children}
  </StyledBalloon>
);

function IconWithTooltip(props) {
  if (!props.onClick || props.hide) return null;

  const onClick = props.onClick ? () => props.onClick() : null;

  return (
    <IconTooltip tooltip={props.tooltip}>
      <StyledIconButton
        color={props.color || ICON_COLOR}
        size={ICON_SIZE_PX}
        icon={props.icon}
        text={props.text}
        placement={props.placement}
        onClick={onClick}
      />
    </IconTooltip>
  );
}

const NOTIFICATIONS = 'Notifications';
const ADD_CHARTS = 'Add Charts';
const DOWNLOAD = 'Download';
const INFO = 'Info';

/**
 * These are the buttons that on the header of the dashboard and property details modal
 *
 * @param {*} props
 */
export function ControlsPalette(props) {
  const { activeTab } = useRootTab();
  const { propertyDeckardId } = useOptionalPropertyDeckardId();
  const isPropertyDetailsPage = Boolean(propertyDeckardId);

  return (
    <Wrapper>
      <SharePopover hide={!isPropertyDetailsPage} />

      {activeTab === URL_NAVS.list && (
        <>
          <AcceptCheckModalButton />
          <AdminApplyFlowButton />
        </>
      )}

      {
        // TODO: took shortcut bc of demo. Do this properly. Use `IconWithTooltip`
        // or, talk to Bing. Ask if ok to mix icons (rsuite, and iconify side by side -if applies-)
        props.onDownloadClick && (
          <IconTooltip tooltip={props.tooltip}>
            <IconButton
              data-cy="download-button"
              onClick={props.onDownloadClick}
              placement="left"
              size="sm"
              icon={<FileDownloadIcon />}
            >
              {DOWNLOAD}
            </IconButton>
          </IconTooltip>
        )
      }

      <IconWithTooltip
        icon="bell-outline"
        tooltip={NOTIFICATIONS}
        onClick={null}
        hide
      />
      <IconWithTooltip
        icon="info-outlined"
        tooltip={INFO}
        onClick={props.onInformationClick}
      />
      <IconWithTooltip
        icon="add-chart-outline"
        onClick={props.addChartClicked}
        tooltip={ADD_CHARTS}
      />
    </Wrapper>
  );
}
